
import React, { useLayoutEffect, useRef, useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { CogIcon, SearchIcon } from '@heroicons/react/solid'
import { DocumentDownloadIcon, DotsHorizontalIcon } from '@heroicons/react/outline'



const statusStyles = {
    Successful: 'bg-green-500 text-white',
    Initiated: 'bg-amber-400 text-white',
    TimedOut: 'bg-orange-600 text-white',
}
const people = [
    {
        customerName: 'Lindsay Walton',
        accounNumber: '09929202929',
        amount: '50000',
        branch: 'Lagos',
        dateInitiated: '25-FEB-1780',
        atmLocationName: 'Obafemi Awolowo',
        reference: 'i88288292',
        status: 'TimedOut',
        dateCompleted: '23-06-1980'
    },
    {
        customerName: 'Lindsay Walton',
        accounNumber: '09929202929',
        amount: '50000',
        branch: 'Lagos',
        dateInitiated: '25-FEB-1780',
        atmLocationName: 'Obafemi Awolowo',
        reference: 'i88288292',
        status: 'Successful',
        dateCompleted: '23-06-1980'
    },
    {
        customerName: 'Lindsay Walton',
        accounNumber: '09929202929',
        amount: '50000',
        branch: 'Lagos',
        dateInitiated: '25-FEB-1780',
        atmLocationName: 'Obafemi Awolowo',
        reference: 'i88288292',
        status: 'Initiated',
        dateCompleted: '23-06-1980'
    },
    // More people...
]
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
export default function Withdrawals() {
    const checkbox = useRef()
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [selectedPeople, setSelectedPeople] = useState([])

    useLayoutEffect(() => {
        const isIndeterminate = selectedPeople.length > 0 && selectedPeople.length < people.length
        setChecked(selectedPeople.length === people.length)
        setIndeterminate(isIndeterminate)
        checkbox.current.indeterminate = isIndeterminate
    }, [selectedPeople])

    function toggleAll() {
        setSelectedPeople(checked || indeterminate ? [] : people)
        setChecked(!checked && !indeterminate)
        setIndeterminate(false)
    }
    return (<>
        <Layout title={'Withdrawals'} current={'/withdrawals'} pageTag={'withdrawal'}>
            <React.Fragment>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>

                    <div className="sm:flex sm:items-center mt-10">
                        <div className="sm:flex-auto flex">
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>
                                <input
                                    type="text"
                                    name="user"
                                    id="user"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                    placeholder="Search customer"
                                />
                            </div>
                            <div className="mt-1 relative rounded-md shadow-sm ml-3">
                                <select
                                    id="currency"
                                    name="currency"
                                    placeholder="Sort by"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                >
                                    <option>Sort by</option>
                                    <option>Name</option>
                                    <option>Account Type</option>
                                </select>

                            </div>
                        </div>
                        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none flex">
                            <button
                                type="button"
                                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>

                        </div>
                    </div>
                    <div className="mt-4 flex flex-col">
                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">

                                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="relative w-12 px-6 sm:w-16 sm:px-8">
                                                    <input
                                                        type="checkbox"
                                                        className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                        ref={checkbox}
                                                        checked={checked}
                                                        onChange={toggleAll}
                                                    />
                                                </th>
                                                <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                    Customer's Name
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 ">
                                                    Account Number
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Amount
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Branch
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Date Initiated
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    ATM Location Name
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Reference Number
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Status
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Date Completed
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {people.map((person) => (
                                                <tr key={person.email} className={selectedPeople.includes(person) ? 'bg-gray-50' : undefined}>
                                                    <td className="relative w-6 px-6 sm:w-16 sm:px-8">
                                                        {selectedPeople.includes(person) && (
                                                            <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                                                        )}
                                                        <input
                                                            type="checkbox"
                                                            className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                            value={person.email}
                                                            checked={selectedPeople.includes(person)}
                                                            onChange={(e) =>
                                                                setSelectedPeople(
                                                                    e.target.checked
                                                                        ? [...selectedPeople, person]
                                                                        : selectedPeople.filter((p) => p !== person)
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                    <td
                                                        className={classNames(
                                                            'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                                                            selectedPeople.includes(person) ? 'text-indigo-600' : 'text-gray-900'
                                                        )}
                                                    >
                                                        {person.customerName}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accounNumber}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.amount}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branch}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.dateInitiated}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.atmLocationName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.reference}</td>
                                                    <td><span className={classNames(
                                                        statusStyles[person.status], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.status}</span></td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.dateCompleted}</td>
                                                    <td><DotsHorizontalIcon className='text-gray-500' /></td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </React.Fragment>
        </Layout></>)
}